
export const CATEGORY_OPTIONS: { value: string; label: string }[] = [
  { value: "system", label: "System" },
  { value: "live_streaming", label: "Live Streaming" },
  { value: "pixel_pilot", label: "Pixel Pilot" },
  { value: "muzukuru", label: "Muzukuru" },
  { value: "chema", label: "Chema" },
  { value: "my_muzukuru", label: "MyMuzukuru" },
];

export const EMAIL_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: "transactional", label: "Transactional" },
  { value: "notification", label: "Notification" },
  { value: "marketing", label: "Marketing" },
  { value: "reminder", label: "Reminder" },
];

export const DESIGN_OPTIONS: { value: string; label: string }[] = [
  { value: "classic", label: "Classic" },
  { value: "minimal", label: "Minimal" },
  { value: "bold_header", label: "Bold Header" },
  { value: "card", label: "Card" },
  { value: "split", label: "Split" },
  { value: "banner_lead", label: "Banner Lead" },
];

export interface EmailTemplateData {

  template_name: string;
  description: string;
  category: string;
  email_type: string;
  trigger: string;

  subject: string;
  heading: string;
  email_message: string;
  button_label: string;
  button_url: string;

  logo_url: string;
  banner_url: string;
  footer_message: string;
  contact_email: string;
  contact_phone: string;

  design_id: string | null;
}

export const initialEmailTemplateValues: EmailTemplateData = {
  template_name: "",
  description: "",
  category: "",
  email_type: "",
  trigger: "",

  subject: "",
  heading: "",
  email_message: "",
  button_label: "",
  button_url: "",

  logo_url: "",
  banner_url: "",
  footer_message: "You are receiving this email because of your relationship with Muzukuru.",
  contact_email: "",
  contact_phone: "",

  design_id: null,
};